import { render, staticRenderFns } from "./edit.teams.page.vue?vue&type=template&id=d88f4d12&"
import script from "./edit.teams.page.vue?vue&type=script&lang=js&"
export * from "./edit.teams.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports